/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_PushInputs */

const en_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const ar_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#دفع`)
};

const bn_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const de_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const es_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const fr_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const pt_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const zh_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const tr_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const ru_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

const pl_svtag_push = /** @type {(inputs: Svtag_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PUSH`)
};

/**
* | output |
* | --- |
* | "#PUSH" |
*
* @param {Svtag_PushInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_push = /** @type {((inputs?: Svtag_PushInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_PushInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_push(inputs)
	if (locale === "bn") return bn_svtag_push(inputs)
	if (locale === "de") return de_svtag_push(inputs)
	if (locale === "es") return es_svtag_push(inputs)
	if (locale === "fr") return fr_svtag_push(inputs)
	if (locale === "pt") return pt_svtag_push(inputs)
	if (locale === "zh") return zh_svtag_push(inputs)
	if (locale === "tr") return tr_svtag_push(inputs)
	if (locale === "ru") return ru_svtag_push(inputs)
	if (locale === "pl") return pl_svtag_push(inputs)
	return en_svtag_push(inputs)
});